"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _moment = _interopRequireDefault(require("moment"));
var _serverTime = require("../../../actions/serverTime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function broadcastSyncedServerTime(_ref, _ref2) {
  var dispatch = _ref.dispatch;
  var serverTime = _ref2.serverTime;
  var directorTime = (0, _moment["default"])().utc().unix();
  var now = _moment["default"].unix(directorTime);
  var then = _moment["default"].unix(serverTime);
  var serverTimeDelta = now.diff(then, 'seconds');
  dispatch((0, _serverTime.setServerTimeDelta)(serverTimeDelta));
}
var _default = exports["default"] = broadcastSyncedServerTime;